import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "redux/reducers";
import { ConfirmDialog } from "components/shared-ui/dialogs/common/confirm-dialog/confirm-dialog";
import styles from "./delete-confirmation.module.scss";
import { iamEntityActions } from "redux/actions/iam-entity";
import { IAMEntityType } from "api/entities/iam-entity";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    closeDeleteConfirmation: () => {
      dispatch(iamEntityActions.deleteConfirmation.close());
    },
  };
};

const mapStateToProps = (state: IAppState) => ({
  isOpen: state.iamEntity.deleteConfirmation.isOpen,
  data: state.iamEntity.deleteConfirmation.data,
});

export interface IDeleteConfirmationProps
  extends ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {
  onDelete: (entityId: string) => void;
  type: IAMEntityType;
}

export const DeleteConfirmation = connect(
  mapStateToProps,
  mapDispatchToProps
)((props: IDeleteConfirmationProps) => {
  function handleConfirm() {
    props.onDelete(props.data);
    props.closeDeleteConfirmation();
  }

  return (
    <ConfirmDialog
      testId={`delete-${props.type}-confirmation`}
      title={`Delete ${props.type}`}
      confirmText="Confirm"
      open={props.isOpen}
      onClose={props.closeDeleteConfirmation}
      onConfirm={handleConfirm}
    >
      <div className={styles.content}>
        Are you sure you want to delete the {props.type}{" "}
        <strong>{props.data}</strong> from Myota? All data will be lost.
      </div>
    </ConfirmDialog>
  );
});
